var Screen = {

	xs: function() {
		if ($(window).width() < 768) return true;
		return false;
	},

	mobile: function() {
		return Screen.xs();
	},

	desktop: function() {
		return Screen.md() || Screen.lg();
	},

	md: function() {
		if ($(window).width() < 1280 && $(window).width() >= 768) return true;
		return false;
	},

	lg: function() {
		if ($(window).width() >= 1280) return true;
		return false;
	},

	isLandscape: function() {
		return $(window).width() > $(window).height();
	},

	isPortrait: function() {
		return $(window).width() < $(window).height();
	}
}